// #region License

/**
 * @license
 * Copyright (C) JVS-Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

// #region Imports

import * as React from 'react';
import BuilderContext from "../../contexts/DataTestIdBuilderContext";

// #endregion
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Composant permettant de rajouter un préfixe au composant enfant utilisant
 * soit le composant Accessor soit le hook useDataTestId
 */
var Prefix = function Prefix(_ref) {
  var value = _ref.value,
    children = _ref.children;
  var builder = React.useContext(BuilderContext);
  var prefixedBuilder = React.useMemo(function () {
    return builder.add(value);
  }, [builder, value]);
  return /*#__PURE__*/_jsx(BuilderContext.Provider, {
    value: prefixedBuilder,
    children: children
  });
};
export default Prefix;